var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 14,
    height: 14,
    rx: 7,
    fill: "#00BA80"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_308_202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9397 4.47703L6.33337 9.08303C6.3024 9.11413 6.2656 9.1388 6.22507 9.15563C6.18454 9.17246 6.14109 9.18113 6.09721 9.18113C6.05332 9.18113 6.00987 9.17246 5.96934 9.15563C5.92881 9.1388 5.89201 9.11413 5.86104 9.08303L4.07971 7.30003C4.04874 7.26894 4.01193 7.24427 3.97141 7.22744C3.93088 7.2106 3.88743 7.20194 3.84354 7.20194C3.79966 7.20194 3.7562 7.2106 3.71568 7.22744C3.67515 7.24427 3.63834 7.26894 3.60737 7.30003C3.57628 7.331 3.55161 7.36781 3.53478 7.40834C3.51794 7.44886 3.50928 7.49232 3.50928 7.5362C3.50928 7.58008 3.51794 7.62354 3.53478 7.66406C3.55161 7.70459 3.57628 7.7414 3.60737 7.77237L5.38937 9.55403C5.57736 9.74167 5.83211 9.84705 6.09771 9.84705C6.36331 9.84705 6.61806 9.74167 6.80604 9.55403L11.412 4.94903C11.4431 4.91807 11.4677 4.88129 11.4845 4.84079C11.5013 4.80029 11.51 4.75688 11.51 4.71303C11.51 4.66919 11.5013 4.62577 11.4845 4.58528C11.4677 4.54478 11.4431 4.508 11.412 4.47703C11.3811 4.44594 11.3443 4.42127 11.3037 4.40444C11.2632 4.3876 11.2198 4.37894 11.1759 4.37894C11.132 4.37894 11.0885 4.3876 11.048 4.40444C11.0075 4.42127 10.9707 4.44594 10.9397 4.47703Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_308_202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(3.5 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheckCircle);
export default __webpack_public_path__ + "static/media/green-check-circle.8dcb57cf4b6a4789c9fe38c4efa67e56.svg";
export { ForwardRef as ReactComponent };